/**
 * @file
 * Show hidden rows
 *
 */
((Drupal, $) => {

  Drupal.behaviors.displaAllFacts = {
    attach: (context, settings) => {
      $( context.getElementsByClassName('display-all product-facts') ).once('display-all-product-facts').on('click', function(e){
        e.preventDefault();
        $( this ).toggleClass('open');
        $( this.previousElementSibling.getElementsByClassName('hidden') ).toggle();
      });
    }
  }

})(Drupal, jQuery);
